<template>
  <div class="content-container" style="height: auto">
    <div class="content-box">
      <div
        ref="agGridWrapper"
        v-loading="tableLoading"
        class="section-box outline"
      >
        <search-comp @onSearch="getList" @onReset="onReset">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhóm nguồn</div>
                    <div class="child-w-80">
                      <!-- v-model="searchParams.roomNumber" -->
                      <!-- <select-with-search-table
                        style="width: 100%"
                        :rows="sourceOptions"
                        :columns="columnsSource"
                        index-field="id"
                        :selected-index-field-value="searchParams.sourceIdList"
                        :value="searchParams.sourceIdList"
                        @selectionChanged="onSelectRowSource"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.code }}
                        </template>
                      </select-with-search-table> -->
                      <select-with-search-table
                        style="width: 100%"
                        :rows="sourceGroupOptions"
                        :columns="columnsGroup"
                        :value="searchParams.sourceIdList"
                        :selected-index-field-value="searchParams.sourceIdList"
                        index-field="id"
                        @selectionChanged="onSelectRowOption"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.code }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParams.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>

                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <CalendarRange
                        v-model="datetimeRange"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">{{
                this.$t('route.chartBySourceGroupReport')
              }}</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div class="grid-scroll mt-10" style="height: 400px">
            <GridVx
              ref="agGrid"
              style="height: 400px"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :pinned-bottom-row-data="pinnedRowData"
            />
          </div>
        </div>
      </div>
      <div v-loading="pieChartLoading" class="section-box outline">
        <search-comp @onSearch="getListPieChart" @onReset="onResetPieChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <CalendarRange
                        v-model="datetimeRangePieChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionPieChart"
                    autoresize
                    @click="handleClickPieChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="lineChartLoading" class="section-box outline">
        <search-comp @onSearch="getListLineChart" @onReset="onResetLineChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Nhóm nguồn</div>
                    <div class="child-w-80">
                      <!-- v-model="searchParams.roomNumber" -->
                      <select-with-search-table
                        style="width: 100%"
                        :rows="sourceOptions"
                        :columns="columnsSource"
                        :multiple="true"
                        index-field="id"
                        :selected-index-field-value="
                          searchParamsLine.sourceIdList
                        "
                        :value="searchParamsLine.sourceIdList"
                        @selectionChanged="onSelectRowSourceLineChart"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <span v-if="selectedData?.length">
                            {{ selectedData.map(item => item.code).join(', ') }}
                          </span>
                        </template>
                      </select-with-search-table>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Từ ngày - Đến ngày</div>
                    <div class="child-w-80">
                      <CalendarRange
                        v-model="datetimeRangeLineChart"
                        style="display: block; width: 500px"
                        mode="date"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionLineChart"
                    autoresize
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <div v-loading="barChartLoading" class="section-box outline">
        <search-comp @onSearch="getListBarChart" @onReset="onResetBarChart">
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Tháng</div>
                    <div class="child-w-80">
                      <el-date-picker
                        v-model="datetimeRangeBarChart"
                        value-format="yyyy-MM"
                        type="month"
                        placeholder="Vui lòng chọn tháng, năm"
                      >
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">Khách sạn</div>
                    <div class="child-w-80">
                      <el-select
                        v-model="searchParamsBar.hotelIdList"
                        collapse-tags
                        multiple
                      >
                        <el-option
                          v-for="(hotel, index) in hotelList"
                          :key="index"
                          :value="hotel.id"
                          :label="hotel.name"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container mt-10">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="chartwithbutton">
                  <vchart
                    style="height: 400px"
                    class="chart"
                    :option="optionHistogramChart"
                    autoresize
                    @click="handleClickBarChart"
                  />
                  <div class="button-containers-title">
                    <button class="btn small primary outline download-button">
                      <i class="el-icon-download"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
      <!-- <div class="content-box"> -->
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>STT: Số thứ tự</li>
            <li>
              Nhóm nguồn: hiển thị Danh sách tên nhóm nguồn (Cấu hình> Kế toán >
              Nhóm nguồn
            </li>
            <li>Người lớn: Tông số lượng người lớn trong Nhóm nguồn</li>
            <li>Trẻ em: Tổng số lượng trẻ em trong Nhóm nguồn</li>
            <li>Số lượng phòng: Số lượng phòng đặt của nhóm nguồn</li>
            <li>
              Số đêm : Hiển thị Số đêm lưu trú của đặt phòng thuộc thời gian tìm
              kiếm của nhóm nguồn
            </li>
            <li>Doanh thu: Doanh thu phòng</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getAllHotel } from '@/api/hotel'
import { getSourceApi } from '@/api/Statistics/source'
import { getSourceGroupApi } from '@/api/Statistics/sourceGroup'
import {
  getSourceRevenueApi,
  getSourceRevenueApiExcel,
  getSourceRevenueLineChartApi
} from '@/api/report_service/report_b'
import { PieChart, BarChart, LineChart } from 'echarts/charts'
import { use } from 'echarts/core'
import InfoBtn from './components/InfoBtn.vue'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { color } from '@/utils/color'

use([BarChart, PieChart, LineChart])

const getOptionHistogramChartDefault = () => ({
  title: {
    text: 'Doanh thu của từng nhóm nguồn'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    formatter: params => {
      var axisLabel = params[0].axisValue
      var tooltipContent = ''
      var total = 0
      params.map(item => {
        total += item.value
      })
      params.forEach(item => {
        if (item.value !== 0) {
          const colorBlock = item.marker
          const percent = ((item.value / total) * 100).toFixed(2)
          tooltipContent += `<div style="display: flex; flex-direction: row;align-items: center; justify-content: space-between; gap: 8px"><span>${colorBlock} ${
            item.seriesName
          }</span> ${item.value.toLocaleString('en-US')} VND(${percent}%)</div>`
        }
      })
      tooltipContent =
        `<span style="font-weight: 600">${axisLabel}</span><br><span style="font-weight: 600">Tổng doanh thu: ${total.toLocaleString(
          'en-US'
        )}VND</span><br>` + tooltipContent
      return tooltipContent
    },
    enterable: true
  },
  legend: {
    orient: 'horizontal',
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 60,
    containLabel: true
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisTick: {
        alignWithLabel: true
      }
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})
const getOptionPieChartDefault = () => ({
  title: {
    text: 'Tỷ lệ doanh thu của từng nhóm nguồn'
    // left: '5%'
  },
  color: color,
  tooltip: {
    trigger: 'item',
    confine: true,
    extraCssText: 'overflow: scroll;text-wrap: wrap;',
    valueFormatter: value => value.toFixed(2) + '%'
  },
  legend: {
    orient: 'vertical',
    type: 'scroll',
    textStyle: {
      width: 300,
      overflow: 'break'
    },
    top: 50,
    left: '5%'
    // bottom: 20
  },
  series: [
    {
      name: 'Doanh thu',
      type: 'pie',
      avoidLabelOverlap: true,
      left: '40%',
      width: '60%',
      radius: '85%',
      data: [],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      }
    }
  ]
})
const getOptionLineChartDefault = () => ({
  // color: ['#5470C6', '#EE6666', '#ccc'],
  title: {
    text: 'Tăng trưởng của từng Nhóm nguồn'
  },
  color: color,
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    confine: true,
    extraCssText: 'height: 300px;overflow: scroll;text-wrap: wrap;',
    valueFormatter: value =>
      value !== null ? value.toLocaleString('en-US') + ' VND' : null,
    enterable: true
  },
  legend: {
    orient: 'horizontal',
    type: 'scroll',
    bottom: 0
  },
  grid: {
    left: '6%',
    right: '4%',
    top: 70,
    bottom: 60
  },
  xAxis: [
    {
      type: 'category',
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        onZero: false
        // lineStyle: {
        //   color: '#5470C6'
        // }
      },
      // axisPointer: {
      //   label: {
      //     formatter: function (params) {
      //       return (
      //         'Doanh thu ' +
      //         params.value +
      //         (params.seriesData.length ? '：' + params.seriesData[0].data : '')
      //       )
      //     }
      //   }
      // },
      // prettier-ignore
      data: []
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: []
})

export default {
  components: {
    CalendarRange,
    InfoBtn,
    SelectWithSearchTable
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      tableLoading: false,
      pieChartLoading: false,
      lineChartLoading: false,
      barChartLoading: false,

      dialogFormVisible: false,
      hotelList: [],

      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          tooltipField: 'code',
          minWidth: 120
        },
        {
          headerName: 'Mô tả',
          tooltipField: 'desc',
          field: 'desc',
          minWidth: 200
        }
      ],
      sourceGroupOptions: [],
      columnsGroup: [
        {
          headerName: 'Mã nhóm',
          field: 'code',
          minWidth: 150,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          flex: 1,
          sortable: false
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      searchParams: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        sourceIdList: [],
        sourceGroupIdList: [],
        hotelIdList: []
      },
      searchParamsDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        sourceIdList: [],
        sourceGroupIdList: [],
        hotelIdList: []
      },
      optionPieChart: getOptionPieChartDefault(),

      optionLineChart: getOptionLineChartDefault(),
      optionHistogramChart: getOptionHistogramChartDefault(),
      columns: [
        {
          headerName: this.$t('grid.column.order'),
          field: 'no',
          tooltipField: 'no',
          minWidth: 70,
          maxWidth: 80,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.sourceGroup'),
          field: 'source_code',
          headerTooltip: this.$t('grid.column.sourceGroup'),
          tooltipField: 'source_code',
          flex: 1,
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.adult'),
          field: 'num_of_adult',
          minWidth: 100,
          maxWidth: 120,
          tooltipField: 'num_of_adult',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.child'),
          field: 'num_of_child',
          maxWidth: 120,
          minWidth: 100,
          tooltipField: 'num_of_child',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'num_of_room',
          maxWidth: 120,
          minWidth: 100,
          headerTooltip: this.$t('grid.column.roomNum'),
          tooltipField: 'num_of_room',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.numNight'),
          minWidth: 100,
          maxWidth: 120,
          field: 'num_of_night',
          headerTooltip: this.$t('grid.column.numNight'),
          tooltipField: 'num_of_night',
          sortable: false
        },

        {
          headerName: this.$t('grid.column.revenue'),
          field: 'revenue',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          minWidth: 100,
          // maxWidth: 200,
          flex: 1,
          cellClass: 'grid-cell-right',
          sortable: false
        },
        {
          headerName: this.$t('grid.column.total'),
          // maxWidth: 200,
          flex: 1,
          minWidth: 100,
          field: 'total',
          cellRenderer: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          tooltipValueGetter: params => {
            return params.value !== null
              ? params.value.toLocaleString('en-US')
              : null
          },
          cellClass: 'grid-cell-right',
          sortable: false
        }
      ],
      rows: [],
      pinnedRowData: null,

      // filter pie chart
      searchParamsPie: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD')
      },
      searchParamsPieDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD')
      },

      // filter line chart
      searchParamsLine: {
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        sourceIdList: []
      },
      searchParamsLineDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        sourceIdList: []
      },

      // filter bar chart
      searchParamsBar: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        // month: this.$moment().month() + 1,
        hotelIdList: []
      },
      searchParamsBarDefault: {
        dateFrom: this.$moment().startOf('month').format('YYYY-MM-DD'),
        dateTo: this.$moment().endOf('month').format('YYYY-MM-DD'),
        // month: this.$moment().month() + 1,
        hotelIdList: []
      }
    }
  },
  computed: {
    datetimeRange: {
      get() {
        return {
          start: this.searchParams.dateFrom,
          end: this.searchParams.dateTo
        }
      },
      set(val) {
        this.searchParams.dateFrom = val.start
        this.searchParams.dateTo = val.end
      }
    },
    datetimeRangePieChart: {
      get() {
        return {
          start: this.searchParamsPie.dateFrom,
          end: this.searchParamsPie.dateTo
        }
      },
      set(val) {
        this.searchParamsPie.dateFrom = val.start
        this.searchParamsPie.dateTo = val.end
      }
    },
    datetimeRangeLineChart: {
      get() {
        return {
          start: this.searchParamsLine.dateFrom,
          end: this.searchParamsLine.dateTo
        }
      },
      set(val) {
        this.searchParamsLine.dateFrom = val.start
        this.searchParamsLine.dateTo = val.end
      }
    },
    datetimeRangeBarChart: {
      get() {
        if (
          this.searchParamsBar.dateFrom !== null &&
          this.searchParamsBar.dateTo !== null
        ) {
          return this.$moment(this.searchParamsBar.dateFrom).format('YYYY-MM')
        }
        return null
      },
      set(val) {
        if (val === null) {
          this.searchParamsBar.dateFrom = null
          this.searchParamsBar.dateTo = null
          return
        }
        this.searchParamsBar.dateFrom = this.$moment(val, 'YYYY-MM')
          .startOf('month')
          .format('YYYY-MM-DD')
        this.searchParamsBar.dateTo = this.$moment(val, 'YYYY-MM')
          .endOf('month')
          .format('YYYY-MM-DD')
      }
    }
  },
  async created() {
    await this.getListHotel()

    // await this.getListSource()
    await this.getSourceGroup()

    await this.getList()
    await this.getListPieChart()
    this.getListLineChart()
    this.getListBarChart()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd === 'excel') {
        getSourceRevenueApiExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'bieu_do_theo_nhom_nguon_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30

      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    onSelectRowOption(val) {
      this.searchParams.sourceIdList = val.id
    },
    async getSourceGroup() {
      const data = await getSourceGroupApi({ isActive: 1 })
      this.sourceGroupOptions = data.data
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    onSelectRowSource(val) {
      this.searchParams.sourceIdList = val.id
    },
    onSelectRowSourceLineChart(val) {
      this.searchParamsLine.sourceIdList = val.map(item => item.id) ?? null
    },
    async getList() {
      if (
        this.searchParams.dateFrom === null ||
        this.searchParams.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.tableLoading = true
      this.rows = []
      await getSourceRevenueApi(this.searchParams)
        .then(res => {
          var data = res.data
          this.rows = data
          const tempPinnedData = {
            no: 'Tổng',
            source_code: null,
            num_of_adult: 0,
            num_of_child: 0,
            num_of_room: 0,
            num_of_night: 0,
            revenue: 0,
            total: 0
          }
          this.rows.map(item => {
            tempPinnedData.num_of_adult += item.num_of_adult
            tempPinnedData.num_of_child += item.num_of_child
            tempPinnedData.num_of_room += item.num_of_room
            tempPinnedData.num_of_night += item.num_of_night
            tempPinnedData.revenue += item.revenue
            tempPinnedData.total += item.total
          })
          this.pinnedRowData = [tempPinnedData]
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    async onReset() {
      this.searchParams = Object.assign({}, this.searchParamsDefault)
      await this.getList()
    },
    async getListPieChart() {
      if (
        this.searchParamsPie.dateFrom === null ||
        this.searchParamsPie.dateTo === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.pieChartLoading = true
      this.optionPieChart = getOptionPieChartDefault()
      // this.rows = []
      await getSourceRevenueApi(this.searchParamsPie)
        .then(res => {
          var data = res.data
          const sortList = res.data.sort((a, b) => b?.revenue - a?.revenue)
          const top9List = sortList.slice(0, 9)
          const otherList = sortList.slice(9)
          const otherListDebtSum = otherList.reduce((acc, item) => {
            return item?.revenue + acc
          }, 0)
          if (otherListDebtSum > 0) {
            top9List.push({
              revenue: otherListDebtSum,
              source_code: 'Others'
            })
          }
          var total = 0
          data.map(item => {
            total = total + item.revenue
          })
          this.optionPieChart.series[0].data = top9List.map(item => {
            return {
              value: (item.revenue / total).toFixed(4) * 100,
              // value: item.revenue,
              name: item.source_code,
              id: item?.source_id
            }
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.pieChartLoading = false
        })
    },
    async onResetPieChart() {
      this.searchParamsPie = Object.assign({}, this.searchParamsPieDefault)
      await this.getListPieChart()
    },
    async getListLineChart() {
      this.optionLineChart = getOptionLineChartDefault()
      // this.rows = []
      if (
        this.searchParamsLine.dateFrom !== null &&
        this.searchParamsLine.dateTo !== null
      ) {
        if (
          this.$moment(this.searchParamsLine.dateTo).diff(
            this.$moment(this.searchParamsLine.dateFrom),
            'days'
          ) < 3
        ) {
          this.$message({
            type: 'error',
            message: 'Khoảng thời gian có độ dài tối thiểu 3 ngày.'
          })
          return
        }
      } else {
        this.$message({
          type: 'error',
          message: 'Vui lòng nhập khoảng thời gian.'
        })
        return
      }
      this.lineChartLoading = true
      await getSourceRevenueLineChartApi(this.searchParamsLine)
        .then(res => {
          var data = res.map
          this.optionLineChart.xAxis[0].data = data.day
          for (var i = 0; i < data.source.length; i++) {
            this.optionLineChart.series[i] = {
              name: data.source[i].source_code,
              id: data.source[i].source_id,
              type: 'line',
              xAxisIndex: 0,
              smooth: true,
              emphasis: {
                focus: 'series'
              },
              data: data.source[i].increaseRevenueReportBySourceList
            }
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.lineChartLoading = false
        })
    },
    async onResetLineChart() {
      this.searchParamsLine = Object.assign({}, this.searchParamsLineDefault)
      await this.getListLineChart()
    },
    async getListBarChart() {
      if (
        this.searchParamsBar.month === null ||
        this.searchParamsBar.year === null
      ) {
        this.$message({
          type: 'error',
          message: 'Vui lòng chọn tháng.'
        })
        return
      }
      this.barChartLoading = true
      this.optionHistogramChart = getOptionHistogramChartDefault()
      // this.rows = []
      await getSourceRevenueLineChartApi(this.searchParamsBar)
        .then(res => {
          var data = res.map
          this.optionHistogramChart.xAxis[0].data = data.day
          for (var i = 0; i < data.source.length; i++) {
            this.optionHistogramChart.series[i] = {
              name: data.source[i].source_code,
              id: data.source[i].source_id,
              type: 'bar',
              stack: 'source',
              label: {
                show: false
                // formatter: params =>
                //   params.value !== 0 ? params.value + '%' : null
              },
              emphasis: {
                focus: 'series'
              },
              data: data.source[i].increaseRevenueReportBySourceList
            }
          }
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.barChartLoading = false
        })
    },
    async onResetBarChart() {
      this.searchParamsBar = Object.assign({}, this.searchParamsBarDefault)
      await this.getListBarChart()
    },
    async handleClickPieChart(e) {
      // change data and time in table filter
      this.searchParams.dateFrom = this.searchParamsPie.dateFrom
      this.searchParams.dateTo = this.searchParamsPie.dateTo
      this.searchParams.sourceIdList = e.data.id
      this.searchParams.hotelIdList = []
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
    },
    async handleClickBarChart(e) {
      this.searchParams.dateFrom = e.name
      this.searchParams.dateTo = e.name
      this.searchParams.hotelIdList = this.searchParamsBar.hotelIdList
      await this.getList()
      this.$refs.agGridWrapper.scrollIntoView({ behavior: 'smooth' })
      // change data and time in table filter
    }
  }
}
</script>

<style lang="scss">
.chartwithbutton {
  position: relative;

  button {
    position: absolute;
    top: 0;
  }
}
.section-box {
  height: auto !important;
}
</style>
